enum NotificationSentimentType {
  Positive = 'positive',
  Neutral = 'neutral',
  Negative = 'negative'
};

export default NotificationSentimentType;
